import { Skeleton } from '@design-system/Skeleton';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@design-system/Carousel';
import { cn } from '@/utils/styles';

interface NutritionPageCommonSkeletonProps {
  className?: string;
}

export const NutritionPageCommonSkeleton = ({
  className,
}: NutritionPageCommonSkeletonProps) => {
  const skeletonItems = Array(4).fill(null);

  return (
    <div>
      <Skeleton className="h-8 w-32 mb-4" />
      <Skeleton className="h-12 max-w-xl mb-6" />
      <Carousel className="w-full relative">
        <CarouselContent>
          {skeletonItems.map((_, index) => (
            <CarouselItem key={index} className="max-w-44 min-h-46 select-none">
              <div className="py-1">
                <Skeleton className={cn("h-[9.5rem] w-36 rounded-2xl", className)} /> 
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>

        <CarouselPrevious variant="ghost" />
        <CarouselNext variant="ghost" />
      </Carousel>
      <Skeleton className="w-full h-12 mt-5 rounded-full" />
      <Skeleton className="w-full h-[4.5rem] mt-5 rounded-xl" />
    </div>
  );
};